var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"condition"},[_c('el-checkbox',{attrs:{"true-label":_vm.trueVal,"false-label":_vm.falseVal},on:{"change":_vm.change},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }